export default "__VITE_ASSET__9d15c033__"